import { HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as CryptoJS from 'crypto-js';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../auth/authentication.service";
var ResultadoService = /** @class */ (function () {
    function ResultadoService(http, auth) {
        this.http = http;
        this.auth = auth;
    }
    ResultadoService.prototype.obterResultadoPdf = function (extraInfo) {
        var options = {
            responseType: 'text',
            headers: new HttpHeaders()
                .append('client_id', environment.auth.client_id)
                .append('access_token', this.auth.accessToken),
            params: new HttpParams()
                .set('listaItens', this.decryptText(extraInfo.listaItens))
                .set('bloqueioPorSenha', true.toString())
        };
        return this.http
            .get(environment.host + "/cliente/v1/fichas/" + this.decryptText(extraInfo.numFicha) + "/resultado-pdf", options);
    };
    ResultadoService.prototype.resultadoVisualizado = function (extraInfo) {
        var options = {
            responseType: 'text',
            headers: new HttpHeaders()
                .append('client_id', environment.auth.client_id)
                .append('access_token', this.auth.accessToken)
        };
        var body = {
            numeroFicha: this.decryptText(extraInfo.numFicha),
            listaItens: this.decryptText(extraInfo.listaItens)
        };
        return this.http
            .put(environment.host + "/resultado-email/v1/visualizado", body, options);
    };
    ResultadoService.prototype.decryptText = function (text) {
        return CryptoJS.AES.decrypt(text, CryptoJS.enc.Base64.parse(btoa(environment.aesSecret)), {
            iv: CryptoJS.enc.Base64.parse(btoa(environment.aesIv)),
            padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8);
    };
    ResultadoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ResultadoService_Factory() { return new ResultadoService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthenticationService)); }, token: ResultadoService, providedIn: "root" });
    return ResultadoService;
}());
export { ResultadoService };
